import './index.css';
import Header from './components/header/Header';
import Main from './components/main/Main';
import AboutUs from './components/aboutus/AboutUs';
import Services from './components/services/Services';
import FAQ from './components/faq/FAQ';
import ServiceDetail from "./components/services/pages/ServicesDetail";
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import Contacts from "./components/contacts/contacts";


function AppContent() {
    const location = useLocation();
    const showHeader = !location.pathname.startsWith('/services/');

    return (
        <div className="App">
            {showHeader && <Header />}
            <main>
                <Routes>
                    <Route path="/" element={<><Main /><Services /><AboutUs /><FAQ /><Contacts /></>} />
                    <Route path="/services/:slug" element={<ServiceDetail />} />
                </Routes>
            </main>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;